<ion-header class="smr-calendar-header ion-no-border">
  <!-- Trial counter -->
  <!-- TODO -->
  <!-- <trial-counter></trial-counter> -->

  <!-- Read Only banner -->
  <smr-subscription-banner></smr-subscription-banner>

  <!-- On Baording-->
  <!-- TODO -->
  <!-- <smr-on-boarding></smr-on-boarding> -->

  <ion-toolbar color="primary" *ngIf="modal">
    <ion-buttons slot="end" *ngIf="modal">
      <ion-button icon-only (click)="onDismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title class="ion-text-center">
      <div class="ion-text-nowrap">Please select a date</div>
    </ion-title>
  </ion-toolbar>

  <ion-toolbar>
    <ion-buttons slot="start">
      <smr-menu-button *ngIf="!modal"></smr-menu-button>

      <ion-back-button mode="md"></ion-back-button>
    </ion-buttons>

    <div style="height: 66px">
      <smr-stylist-picker
        *ngIf="showStylistPicker"
        (onInit)="onStylistPickerInit($event)"
        (stylistSelect)="onStylistSelectChange($event)"
        [readOnly]="readOnlyStylistPicker"
        [hidden]="errorOccurredWhileLoadingStylistPicker"
        [disabled]="isCalendarLoading"
        cssClass="smr-stylist-picker-for-calendar"
        [stylistID]="stylistID"
        [withCalendarOnly]="true"
        [showAllStaff]="true"
        [allStaffViewMode]="allStaffViewMode"
      >
      </smr-stylist-picker>
    </div>

    <ion-buttons slot="end" *ngIf="!allStaffViewMode">
      <ion-button (click)="onCalendarSettings($event)">
        <ion-icon name="settings"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <ion-toolbar class="smr-calendar-daterange-toolbar ion-text-center">
    <ion-buttons slot="start">
      <ion-button
        icon-only
        (click)="moveCalendarBackwards()"
        [disabled]="isCalendarLoading || errorOccurredWhileLoadingStylistPicker"
      >
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title
      class="ion-no-padding"
      *ngIf="!isCalendarLoading && !errorOccurredWhileLoadingStylistPicker"
    >
      <ion-button
        class="smr-calendar-daterange"
        color="dark"
        icon-right
        fill="clear"
        (click)="onJumpCalendarDate()"
        [disabled]="isCalendarLoading || errorOccurredWhileLoadingStylistPicker"
      >
        {{ title }}&nbsp;
        <ion-icon name="chevron-down-outline"></ion-icon>
      </ion-button>
      <ion-button
        color="dark"
        (click)="onToday()"
        fill="clear"
        class="smr-button-today"
      >
        Today
      </ion-button>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button
        icon-only
        (click)="moveCalendarForward()"
        [disabled]="isCalendarLoading || errorOccurredWhileLoadingStylistPicker"
      >
        <ion-icon name="arrow-forward-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar *ngIf="isMobile && views.count() == 1">
    <smr-calendar-date-picker
      [selectedDate]="currentDate"
      (newSelectedDate)="selectDate($event)"
    ></smr-calendar-date-picker>
  </ion-toolbar>
  <ion-toolbar
    class="smr-calendar-column-heading-toolbar ion-no-padding"
    *ngIf="views.count() > 1 && !allStaffViewMode"
  >
    <ion-grid class="ion-no-padding">
      <ion-row
        class="ion-no-padding"
        *ngIf="!allStaffViewMode && views.count() > 1"
      >
        <ng-container *ngFor="let view of views; let viewIndex = index">
          <ion-col
            [ngStyle]="{ flex: viewIndex == 0 ? '0 0 60px' : '0 0 75px' }"
            *ngIf="viewIndex % 2 == 0 && !isMediumScreen && !isMobile"
          >
          </ion-col>
          <ion-col
            style="flex: 0 0 40px"
            *ngIf="viewIndex % 2 == 0 && isMediumScreen"
          >
          </ion-col>
          <ion-col style="flex: 0 0 40px" *ngIf="viewIndex == 0 && isMobile">
          </ion-col>
          <ion-col
            class="ion-text-center"
            [ngStyle]="{ width: isMediumScreen ? view.width : view.width }"
            [ngClass]="{
              'smr-calendar-today':
                utilities.formatDate(todaysDate, 'MMM DD Y') ==
                utilities.formatDate(view.date, 'MMM DD Y')
            }"
          >
            <ion-button
              color="dark"
              class="smr-calendar-column-heading"
              [ngStyle]="{ 'font-size': getFontSize() }"
              fill="clear"
              expand="block"
              (click)="switchToAllStaffMode(view.date)"
              [disabled]="isCalendarLoading || stylistNum == 1"
              >{{ view.date | salonMonsterDate : "ddd" }}&nbsp;<b>{{
                view.date | salonMonsterDate : " D"
              }}</b>
            </ion-button>
          </ion-col>
        </ng-container>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-header>

<ion-content
  class="smr-calendar-outer"
  [ngClass]="{ 'smr-all-stylist-view-outer': allStaffViewMode }"
>
  <smr-all-stylist-view-calendar
    *ngIf="allStaffViewMode"
    [hidden]="
      isCalendarLoading ||
      errorOccurredWhileLoadingCalendarEvents ||
      errorOccurredWhileLoadingStylistPicker
    "
    [currentDate]="currentDate"
    [muteEventTappability]="muteEventTappability"
    (onEventSelected)="eventSelectedHandler($event)"
    (onTimeSelected)="onTimeSelectedHandler($event)"
    (onRangeChanged)="onRangeChangedHandler($event)"
    (eventsBeforeUpdate)="onEventsBeforeUpdate($event)"
    (eventsDidUpdate)="onEventsDidUpdate($event)"
    (onEventDragEnd)="onEventDragEndHandler($event)"
    (onStylistHeaderSelected)="onStylistSelectChange($event)"
    (onError)="onError()"
  >
  </smr-all-stylist-view-calendar>

  <smr-week-view-calendar
    *ngIf="!allStaffViewMode"
    [hidden]="
      isCalendarLoading ||
      errorOccurredWhileLoadingCalendarEvents ||
      errorOccurredWhileLoadingStylistPicker
    "
    [currentDate]="currentDate"
    [muteEventTappability]="muteEventTappability"
    [stylist]="stylist"
    [daysToDisplay]="daysToDisplay"
    (onEventSelected)="eventSelectedHandler($event)"
    (onTimeSelected)="onTimeSelectedHandler($event)"
    (onRangeChanged)="onRangeChangedHandler($event)"
    (onViewChanged)="onViewsChanged($event)"
    (eventsBeforeUpdate)="onEventsBeforeUpdate($event)"
    (eventsDidUpdate)="onEventsDidUpdate($event)"
    (onEventDragEnd)="onEventDragEndHandler($event)"
    (onError)="onError()"
    (newSelectedDate)="selectDate($event)"
  >
  </smr-week-view-calendar>

  <salonmonster-load-mask *ngIf="isCalendarLoading"></salonmonster-load-mask>

  <salonmonster-tap-retry
    *ngIf="
      errorOccurredWhileLoadingCalendarEvents ||
      errorOccurredWhileLoadingStylistPicker
    "
    (click)="onTapToReload()"
  ></salonmonster-tap-retry>
</ion-content>
